import React from "react"
import UserNavMenu from "./UserNavMenu"

export default function UserNavDropdown({ close }) {
  return <UserNavMenu close={close} dropdown />
}
